import React from "react"
import { translate } from "translate"

const Badge = ( { product } ) => {
  if ( !product.extras ) return null
  let out = []
  if ( product.extras.neuh === "J" ) {
    out.push( <div key={1} className="badge badge--neu"><span>{translate( "shop.new" )}</span></div> )
  }
  if ( product.extras.alter === "J" ) {
    out.push( <div key={2} className="badge badge--alter"><span>18+</span></div> )
  }
  if ( out.length > 0 ) return <div className="badges">{out}</div>
  return null
}

export default Badge



// WEBPACK FOOTER //
// ./src/components/Product/Badge.js